import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    height: 100%;
    flex: 1;
    color: #fff;
    padding: 20px 20px 10px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
`;

export const Row = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;

    & > * {
        flex: 1;
        width: auto;
        margin-left: 10px;
    }
    & > *:first-child {
        margin-left: 0;
    }
`;

export const Alert = styled.div`
    color: #999;
    font-size: 14px;
    margin: 10px 0;
    border: 1px solid rgba(100,100,255, 0.5);
    background-color: rgba(100,100,255, 0.2);
    padding: 10px;
`;

export const Section = styled.div`
    color: #999;
    font-size: 12px;
    text-transform: uppercase;
    height: 12px;

    &.confirmationLabel {
        margin: 10px 0 0 10px;
    }

    &.spaceshared {
        flex: 1;
    }
`;

export const Field = styled.input`
    color: #999;
    background-color: #111;
    border: 1px solid #444;
    font-size: 14px;
    height: 30px;
    min-height: 30px;
    margin: 2px 0 20px 10px;

    &.solo {
        width: 100%;
        margin: 2px 0 20px 0;
    }
`;

export const FieldSelect = styled.select`
    color: #999;
    background-color: #111;
    border: 1px solid #444;
    font-size: 14px;
    height: 30px;
    min-height: 30px;
    margin: 2px 0 20px 10px;

    &.solo {
        width: 100%;
        margin: 2px 0 20px 0;
    }
`;

export const ActionButtonWrapper = styled.div`
    width: 100%;
    margin: 5px 0 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    height: 35px;
    min-height: 35px;

    &.spaceshared {
        width: auto;
        flex: 1;
    }
`;

export const ActionButton = styled.div.attrs(props => ({
    style: props.width ? {
        width: props.width
    } : {
        flex: 1
    }
}))`
    height: 30px;
    background-color: transparent;
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    transition: all .4s ease 0s;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    :hover {
        background-color: ${props => props.color};
        color: #000;
    }

    &:not(:first-child) {
        margin-left: 10px;
    }

    &.disabled {
        opacity: 0.4;
        cursor: default;
    }
`;

export const AssetsList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;
    flex: 1;
    margin-top: 10px;
`;

export const ConfirmMessage = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 60%;
    font-size: 12px;
    line-height: 18px;
    padding: 0 10px 0 0;
    box-sizing: border-box;
    color: #999;
    text-transform: uppercase;
`;

export const AssetsItemName = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
`;

export const AssetItemIcon = styled.div`
    width: 20px;
    height: 20px;
    margin-right: 5px;
    color: #999;
    font-size: 20px;
    position: relative;

    &:before {
        font-family: 'Material Design Icons';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    &.type0:before {
        content: '\\F09AA';
    }
    &.type1:before {
        content: '\\F02E9';
    }
    &.type2:before {
        content: '\\F04EB';
    }

    &.visibility0:before {
        content: '\\F033E';
    }
    &.visibility1:before {
        content: '\\F0208';
    }
    &.visibility2:before {
        content: '\\F0420';
    }
`;

export const AssetItem = styled.div`
    width: 100%;
    height: 50px;
    padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;

    &:hover {
        background-color: #333;
    }
`;

export const NoAssets = styled.div`
    flex: 1;
    width: 100%;
    color: #666;
    text-align: center;
    padding: 0 80px;
    line-height: 25px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:before {
        font-family: 'Material Design Icons';
        font-size: 150px;
        color: #333;
        content: '\\F0BC2';
        margin-bottom: 80px;
    }
    
`;